<div class="row">
  <inspection-status
    [inspection]="inspection"
    [statusList]="statusList"
    (toggleSaveStatus)="updateStatus($event)"
    (toggleCancel)="cancel()"
  ></inspection-status>
</div>
